export default "__VITE_ASSET__xKojqxX4__"